import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { Suspense } from "react";

import SideModal from "./Component/SideModal";
import Loader from "./Common/V2/Loader";
import Route from "./route";
function App() {
  return (
    <>
        <Suspense
          fallback={
            <Loader
              loading={true}
              loadingText="Loading..."
              style={{ backgroundColor: "var(--theme-colordiv)" }}
            />
          }
        >
          <Route />
        </Suspense>
        <SideModal />
    </>
  );
}

export default App;
